"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendPostBackToPostActivitySaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _postActivity = _interopRequireDefault(require("../actions/postActivity"));

var _sendPostBack = require("../actions/sendPostBack");

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(postActivityWithPostBack),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(sendPostBackToPostActivity),
    _marked3 = /*#__PURE__*/_regenerator["default"].mark(sendPostBackToPostActivitySaga);

// https://github.com/microsoft/botframework-sdk/blob/main/specs/botframework-activity/botframework-activity.md#post-back
function postActivityWithPostBack(_ref) {
  var value;
  return _regenerator["default"].wrap(function postActivityWithPostBack$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          value = _ref.payload.value;
          _context.next = 3;
          return (0, _effects.put)((0, _postActivity["default"])({
            channelData: {
              postBack: true
            },
            text: typeof value === 'string' ? value : undefined,
            type: 'message',
            value: typeof value !== 'string' ? value : undefined
          }));

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function sendPostBackToPostActivity() {
  return _regenerator["default"].wrap(function sendPostBackToPostActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_sendPostBack.SEND_POST_BACK, postActivityWithPostBack);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function sendPostBackToPostActivitySaga() {
  return _regenerator["default"].wrap(function sendPostBackToPostActivitySaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(sendPostBackToPostActivity);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJwb3N0QWN0aXZpdHlXaXRoUG9zdEJhY2siLCJzZW5kUG9zdEJhY2tUb1Bvc3RBY3Rpdml0eSIsInNlbmRQb3N0QmFja1RvUG9zdEFjdGl2aXR5U2FnYSIsInZhbHVlIiwicGF5bG9hZCIsInB1dCIsInBvc3RBY3Rpdml0eSIsImNoYW5uZWxEYXRhIiwicG9zdEJhY2siLCJ0ZXh0IiwidW5kZWZpbmVkIiwidHlwZSIsInRha2VFdmVyeSIsIlNFTkRfUE9TVF9CQUNLIiwid2hpbGVDb25uZWN0ZWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2FnYXMvc2VuZFBvc3RCYWNrVG9Qb3N0QWN0aXZpdHlTYWdhLmpzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIFRoaXMgaXMgZm9yIHRoZSB0ZXJuYXJ5IG9wZXJhdG9yIG9mIHRleHQgYW5kIHZhbHVlLlxuLyogZXNsaW50IG5vLXVuZGVmaW5lZDogXCJvZmZcIiAqL1xuXG5pbXBvcnQgeyBwdXQsIHRha2VFdmVyeSB9IGZyb20gJ3JlZHV4LXNhZ2EvZWZmZWN0cyc7XG5pbXBvcnQgcG9zdEFjdGl2aXR5IGZyb20gJy4uL2FjdGlvbnMvcG9zdEFjdGl2aXR5JztcbmltcG9ydCB7IFNFTkRfUE9TVF9CQUNLIH0gZnJvbSAnLi4vYWN0aW9ucy9zZW5kUG9zdEJhY2snO1xuaW1wb3J0IHdoaWxlQ29ubmVjdGVkIGZyb20gJy4vZWZmZWN0cy93aGlsZUNvbm5lY3RlZCc7XG5cbi8vIGh0dHBzOi8vZ2l0aHViLmNvbS9taWNyb3NvZnQvYm90ZnJhbWV3b3JrLXNkay9ibG9iL21haW4vc3BlY3MvYm90ZnJhbWV3b3JrLWFjdGl2aXR5L2JvdGZyYW1ld29yay1hY3Rpdml0eS5tZCNwb3N0LWJhY2tcbmZ1bmN0aW9uKiBwb3N0QWN0aXZpdHlXaXRoUG9zdEJhY2soeyBwYXlsb2FkOiB7IHZhbHVlIH0gfSkge1xuICB5aWVsZCBwdXQoXG4gICAgcG9zdEFjdGl2aXR5KHtcbiAgICAgIGNoYW5uZWxEYXRhOiB7XG4gICAgICAgIHBvc3RCYWNrOiB0cnVlXG4gICAgICB9LFxuICAgICAgdGV4dDogdHlwZW9mIHZhbHVlID09PSAnc3RyaW5nJyA/IHZhbHVlIDogdW5kZWZpbmVkLFxuICAgICAgdHlwZTogJ21lc3NhZ2UnLFxuICAgICAgdmFsdWU6IHR5cGVvZiB2YWx1ZSAhPT0gJ3N0cmluZycgPyB2YWx1ZSA6IHVuZGVmaW5lZFxuICAgIH0pXG4gICk7XG59XG5cbmZ1bmN0aW9uKiBzZW5kUG9zdEJhY2tUb1Bvc3RBY3Rpdml0eSgpIHtcbiAgeWllbGQgdGFrZUV2ZXJ5KFNFTkRfUE9TVF9CQUNLLCBwb3N0QWN0aXZpdHlXaXRoUG9zdEJhY2spO1xufVxuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiogc2VuZFBvc3RCYWNrVG9Qb3N0QWN0aXZpdHlTYWdhKCkge1xuICB5aWVsZCB3aGlsZUNvbm5lY3RlZChzZW5kUG9zdEJhY2tUb1Bvc3RBY3Rpdml0eSk7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBR0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O3dEQUdVQSx3Qjt5REFhQUMsMEI7eURBSWVDLDhCOztBQWxCekI7QUFDQSxTQUFVRix3QkFBVjtFQUFBO0VBQUE7SUFBQTtNQUFBO1FBQUE7VUFBZ0RHLEtBQWhELFFBQXFDQyxPQUFyQyxDQUFnREQsS0FBaEQ7VUFBQTtVQUNFLE9BQU0sSUFBQUUsWUFBQSxFQUNKLElBQUFDLHdCQUFBLEVBQWE7WUFDWEMsV0FBVyxFQUFFO2NBQ1hDLFFBQVEsRUFBRTtZQURDLENBREY7WUFJWEMsSUFBSSxFQUFFLE9BQU9OLEtBQVAsS0FBaUIsUUFBakIsR0FBNEJBLEtBQTVCLEdBQW9DTyxTQUovQjtZQUtYQyxJQUFJLEVBQUUsU0FMSztZQU1YUixLQUFLLEVBQUUsT0FBT0EsS0FBUCxLQUFpQixRQUFqQixHQUE0QkEsS0FBNUIsR0FBb0NPO1VBTmhDLENBQWIsQ0FESSxDQUFOOztRQURGO1FBQUE7VUFBQTtNQUFBO0lBQUE7RUFBQTtBQUFBOztBQWFBLFNBQVVULDBCQUFWO0VBQUE7SUFBQTtNQUFBO1FBQUE7VUFBQTtVQUNFLE9BQU0sSUFBQVcsa0JBQUEsRUFBVUMsNEJBQVYsRUFBMEJiLHdCQUExQixDQUFOOztRQURGO1FBQUE7VUFBQTtNQUFBO0lBQUE7RUFBQTtBQUFBOztBQUllLFNBQVVFLDhCQUFWO0VBQUE7SUFBQTtNQUFBO1FBQUE7VUFBQTtVQUNiLE9BQU0sSUFBQVksMEJBQUEsRUFBZWIsMEJBQWYsQ0FBTjs7UUFEYTtRQUFBO1VBQUE7TUFBQTtJQUFBO0VBQUE7QUFBQSJ9